// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-header {
  --background: none;
}

.price {
  font-weight: bold;
  font-size: 14px;
}

.empty-box {
  margin-bottom: 40px;
}

.cart-icon {
  font-size: 100px;
  color: #d2d2d2;
  padding-top: 50px;
}

.charge-box {
  border-top: 4px solid #878181;
}

.charge-box {
  padding: 0 0 5px 0;
  font-size: 22px;
  border-top: 4px solid #878181;
}
.charge-box .title {
  padding: 1px 5px;
  background: #eaeaea;
  min-height: 3px;
}
.charge-box .total-row {
  font-weight: bold;
}
.charge-box ion-list, .charge-box ion-item {
  background: none;
  --background: none;
}
.charge-box ion-label {
  padding: 0 20px;
}
.charge-box ion-note {
  font-size: 15px;
}
.charge-box ion-item.total {
  font-size: 1rem;
}
.charge-box ion-item.total ion-note {
  font-size: 23px;
  color: #404040;
}

.element-background ion-item.total ion-note {
  color: var(--element-color);
  --color: var(--element-color);
}

ion-col.main-col {
  padding: 0 5px;
}

.filters-row {
  --background: var(--button-a-background);
  --color: var(--button-a-text);
  --min-height: 36px;
}
.filters-row .view-btn {
  width: -moz-fit-content;
  width: fit-content;
}
.filters-row .view-btn.active {
  opacity: 0.5;
}
.filters-row ion-buttons ion-button.button-clear {
  height: 36px;
}

.big .cart-item-box {
  padding: 2px;
}

.options-box {
  background: #fff;
  padding: 1px 17px;
  text-align: end;
}

.msgs-box {
  padding: 10px;
}

.msgs-box.warning {
  color: #d33939;
}

.action-close-icon {
  position: absolute;
  top: 10px;
  right: 5px;
  font-size: 25px;
}

.ion-margin-bottom {
  margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/cart/cart.page.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;;AAIA;EACE,iBAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAIA;EACE,kBAAA;EACA,eAAA;EACA,6BAAA;AADF;AAIE;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;AAFJ;AASE;EACE,iBAAA;AAPJ;AAUE;EACE,gBAAA;EACA,kBAAA;AARJ;AAYE;EACE,eAAA;AAVJ;AAaE;EACE,eAAA;AAXJ;AAcE;EACE,eAAA;AAZJ;AAcI;EACE,eAAA;EACA,cAAA;AAZN;;AAmBI;EACE,2BAAA;EACA,6BAAA;AAhBN;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EAIE,wCAAA;EACA,6BAAA;EACA,kBAAA;AArBF;AA0BE;EACE,uBAAA;EAAA,kBAAA;AAxBJ;AA2BE;EACE,YAAA;AAzBJ;AAoCE;EAEI,YAAA;AAnCN;;AAgDE;EACE,YAAA;AA7CJ;;AAiDA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;AA9CF;;AAiDA;EACE,aAAA;AA9CF;;AAiDA;EACE,cAAA;AA9CF;;AAiDA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AA9CF;;AAiDA;EACE,kBAAA;AA9CF","sourcesContent":["\n\n.cart-header {\n  --background: none;\n}\n\n.price {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.empty-box {\n  margin-bottom: 40px;\n}\n\n.cart-icon {\n  font-size: 100px;\n  color: #d2d2d2;\n  padding-top: 50px;\n}\n\n.charge-box {\n  border-top: 4px solid #878181;\n}\n\n.charge-box {\n  padding: 0 0 5px 0;\n  font-size: 22px;\n  border-top: 4px solid #878181;\n\n\n  .title {\n    padding: 1px 5px;\n    background: #eaeaea;\n    min-height: 3px;\n  }\n\n  .label {\n    //margin: 0 5px;\n  }\n\n  .total-row {\n    font-weight: bold;\n  }\n\n  ion-list, ion-item {\n    background: none;\n    --background: none;\n    //padding: 0 10px;\n  }\n\n  ion-label {\n    padding: 0 20px;\n  }\n\n  ion-note {\n    font-size: 15px;\n  }\n\n  ion-item.total {\n    font-size: 1rem;\n\n    ion-note {\n      font-size: 23px;\n      color: #404040;\n    }\n  }\n}\n\n.element-background {\n  ion-item.total {\n    ion-note {\n      color: var(--element-color);\n      --color: var(--element-color);\n    }\n  }\n}\n\nion-col.main-col {\n  padding: 0 5px;\n}\n\n.filters-row {\n  //box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 0px 5px 0 rgba(0, 0, 0, .12);\n  //border-radius: 3px;\n\n  --background: var(--button-a-background);\n  --color: var(--button-a-text);\n  --min-height: 36px;\n\n  //margin: 5px 0;\n  //padding: 0 4px;\n\n  .view-btn {\n    width: fit-content;\n  }\n\n  .view-btn.active {\n    opacity: 0.5;\n  }\n\n  //ion-chip {\n  //  margin: 0 10px;\n  //  --background: var(--button-a-text);\n  //  --color: var(--button-a-background);\n  //  padding: 10px;\n  //  height: 26px;\n  //}\n\n  ion-buttons ion-button.button-clear {\n    //--color: var(--button-a-text);\n      height: 36px;\n    //--color-activated: var(--button-a-text);\n  }\n  //\n  //:host ::ng-deep {\n  //  ion-button.button-clear {\n  //    --color: var(--button-a-text);\n  //    --color-activated: var(--button-a-text);\n  //  }\n  //}\n}\n\n.big {\n  .cart-item-box {\n    padding: 2px;\n  }\n}\n\n.options-box {\n  background: #fff;\n  padding: 1px 17px;\n  text-align: end;\n}\n\n.msgs-box {\n  padding: 10px;\n}\n\n.msgs-box.warning {\n  color: #d33939;\n}\n\n.action-close-icon {\n  position: absolute;\n  top: 10px;\n  right: 5px;\n  font-size: 25px;\n}\n\n.ion-margin-bottom {\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
